import React, {useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../Shared/TextInput/TextInput';
import MainTitleComponent from '../Headline/MainTitleComponent';
import {Label, FormGroup} from 'reactstrap';
import {
  gAChangePPBundleError,
  gAChangePPSubStatusError,
  gAChangePPNotAvailableForLimitedError,
  gAChangePPErrorOnChangeLimited,
  gAChangePPErrorOnChange,
  gAChangePPServerError,
  gAChangePPCallBackRequestFailed,
  gAChangePPSubStatusCallBackRequestFailed,
  gAChangePPNotAvailableForLimitedCallBackRequestFailed,
  gAChangePPCallBackRequestFailedForLimited,
  gAChangePPBundleCallBackRequestFailed,
  gAChangePPBundleCallBackRequest,
  gAChangePPSubStatusCallBackRequest,
  gAChangePPNotAvailableForLimitedCallBackRequest,
  gAChangePPCallBackRequestForLimited,
  gAChangePPCallBackRequest,
} from './../reports/gaReports';
import {dwhErrorPageDisplay} from './../reports/dwhReports';

const ErrorWithCallBackComponent = ({props, callBackRequest, startOver}) => {
  const {titleBold = '', description = ''} = props.data.errorData;
  const {changeCallbackHandler} = props;
  let currentOfferId = props.data.selectedAccount?.pricePlan;
  const pageURL = window.location.href;
  const customerName = `${props.userData.loginData?.userDetails?.firstName} ${props.userData.loginData?.userDetails?.lastName}`;
  const id = props.userData.loginData?.userDetails?.IDNumber;
  const subscriber = props.userData.loginData?.userDetails?.contactNumber;
  const phoneNumber = props.data.selectedAccount?.subscriberNo;
  const stepName = props.data.errorStep;
  const message = props.data.errorReason;
  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    changeCallbackHandler({value: props.data.callBackPhone.phone, rule: props.data.callBackPhone.rules});
    switch (props.data.errorReason) {
      case 'bundle':
        gAChangePPBundleError();
        break;
      case 'sub_status':
        gAChangePPSubStatusError();
        break;
      case 'fix_price_with_futurePP':
        gAChangePPNotAvailableForLimitedError();
        break;
      case 'error_on_change':
        if (props.data.selectedAccountExtendedData && props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
          gAChangePPErrorOnChangeLimited();
        } else {
          gAChangePPErrorOnChange();
        }
        break;
      case 'server_error':
        gAChangePPServerError();
        //DWH
        if (stepName) {
          dwhErrorPageDisplay({currentOfferId, subscriber, pageURL, customerName, id, message, stepName, phoneNumber});
        }

        break;
      default:
      // code block
    }

    props.saveToHistory('callback');
  }, []);

  useEffect(() => {
    if (props.data.callBackRequestFailed) {
      switch (props.data.errorReason) {
        case 'bundle':
          gAChangePPBundleCallBackRequestFailed();
          break;
        case 'sub_status':
          gAChangePPSubStatusCallBackRequestFailed();
          break;
        case 'fix_price_with_futurePP':
          gAChangePPNotAvailableForLimitedCallBackRequestFailed();
          break;
        case 'error_on_change':
          if (props.data.selectedAccountExtendedData && props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
            gAChangePPCallBackRequestFailedForLimited();
          } else {
            gAChangePPCallBackRequestFailed();
          }

        default:
        // code block
      }
    }
  }, [props.data.callBackRequestFailed]);

  const validateRequest = () => {
    if (props.data.callBackPhone.valid) {
      switch (props.data.errorReason) {
        case 'bundle':
          gAChangePPBundleCallBackRequest();
          break;
        case 'sub_status':
          gAChangePPSubStatusCallBackRequest();
          break;
        case 'fix_price_with_futurePP':
          gAChangePPNotAvailableForLimitedCallBackRequest();
          break;
        case 'error_on_change':
          if (props.data.selectedAccountExtendedData && props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
            gAChangePPCallBackRequestForLimited();
          } else {
            gAChangePPCallBackRequest();
          }

          break;
        default:
        // code block
      }
      callBackRequest();
    }
  };

  return (
    <>
      <MainTitleComponent title={'שינוי חבילת סלולר'} />
      <div className='failure-container with-call-back'>
        <div className=' d-flex justify-content-center'>
          <div className='bold main-text d-block'>
            <p dangerouslySetInnerHTML={{__html: titleBold}} />
          </div>
        </div>
        {description.trim() != '' && (
          <div className='d-flex justify-content-center text-center'>
            <div className='description'>
              <p dangerouslySetInnerHTML={{__html: description}} />
            </div>
          </div>
        )}
        <div className='d-flex justify-content-center'>
          <div className=' background-container'>
            <FormGroup>
              <Label for='phone' className='bold'>
                לאיזה טלפון להתקשר?
              </Label>
              <TextInput
                onChange={(e) => changeCallbackHandler({
                  name: e.target.name,
                  value: e.target.value,
                  rule: props.data.callBackPhone.rules
                })}
                value={props.data.callBackPhone.phone}
                error={props.data.callBackPhone.errors}
                name='callbackPhone'
                type='text'
                placeholder='מספר טלפון'
                id='callbackPhone'
                required='required'
              />
            </FormGroup>
          </div>
        </div>
        {props.data.callBackRequestFailed && (
          <div className='d-flex justify-content-center'>
            <p className='pink-text failure-and-failure text-center'>
              רגע, הייתה תקלה והמספר לא נשלח. <br /> אפשר לדבר איתנו ב-{window.Config.technicalSupportPhone} ונשמח לעזור
            </p>
          </div>
        )}
        <div className='d-flex justify-content-center'>
          <div className='btn-wrapper'>
            <BtnSubmit
              formid='failure-screen'
              onclick={!props.data.callBackRequestFailed ? () => validateRequest() : startOver()}
              text={props.data.callBackRequestFailed ? 'אוקיי' : 'תחזרו אלי'}></BtnSubmit>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorWithCallBackComponent;
